import { render } from "./OnTheWayOrders.vue?vue&type=template&id=07452aaa&scoped=true"
import script from "./OnTheWayOrders.vue?vue&type=script&lang=js"
export * from "./OnTheWayOrders.vue?vue&type=script&lang=js"

import "./OnTheWayOrders.vue?vue&type=style&index=0&id=07452aaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07452aaa"]])

export default __exports__